import { formatRegionLabel } from "../constants/regions.js";
import { normalizeSearch } from "./stringUtils.js";

function normStr(value) {
  return String(value ?? "").trim();
}

function includesRegion(location, regionLabel) {
  const locationText = normalizeSearch(normStr(location));
  const regionText = normalizeSearch(normStr(regionLabel));
  return Boolean(locationText && regionText && locationText.includes(regionText));
}

export function formatEventLocation(event, fallback = "—") {
  const venue = event?.primary_venue || event?.primaryVenue || null;
  const base = normStr(venue?.name)
    || normStr(event?.primary_venue_name)
    || normStr(event?.primaryVenueName)
    || normStr(event?.location)
    || normStr(event?.city);
  const regionLabel = formatRegionLabel(venue?.region || event?.region);

  if (!base) return regionLabel || fallback;
  if (!regionLabel || includesRegion(base, regionLabel)) return base;
  return `${base}, ${regionLabel}`;
}

export function buildGoogleMapsUrl(parts) {
  const query = Array.isArray(parts)
    ? parts.map(normStr).filter(Boolean).join(", ")
    : normStr(parts);

  if (!query) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

export function getEventMapsUrl(event) {
  const venue = event?.primary_venue || event?.primaryVenue || null;
  return buildGoogleMapsUrl([
    venue?.name || event?.primary_venue_name || event?.primaryVenueName,
    venue?.address || event?.location,
    venue?.city || event?.city,
    formatRegionLabel(venue?.region || event?.region),
    "España",
  ]);
}
